module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/prompt-management/view"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Prompt Management")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row equal-height"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createOrUpdatePrompt.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "sandbox-panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Prompt Configuration")]), _vm._v(" "), _c('nv-select', {
    staticClass: "sandbox-version-select",
    attrs: {
      "placeholder": "Version"
    },
    on: {
      "change": _vm.onVersionChange
    },
    model: {
      value: (_vm.selectedPromptVersion),
      callback: function($$v) {
        _vm.selectedPromptVersion = $$v
      },
      expression: "selectedPromptVersion"
    }
  }, _vm._l((_vm.promptVersions), function(version) {
    return _c('option', {
      key: version,
      domProps: {
        "value": version
      }
    }, [_vm._v("\n                        " + _vm._s(version) + "\n                      ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "prompt_name"
    }
  }, [_vm._v("Prompt Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.promptData.prompt_name),
      expression: "promptData.prompt_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "prompt_name",
      "placeholder": "Enter Prompt Name"
    },
    domProps: {
      "value": (_vm.promptData.prompt_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData, "prompt_name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.prompt_name.$error && _vm.$v.promptData.prompt_name.$dirty),
      expression: "$v.promptData.prompt_name.$error && $v.promptData.prompt_name.$dirty"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Prompt Name is required")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "prompt"
    }
  }, [_vm._v("Actual Prompt\n                        ("), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#1a73e8",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.toggleGenAIOnboardingVariable
    }
  }, [_vm._v(_vm._s(_vm.showGenAIOnboardingVairableToggle ? 'Hide' : 'Show') + " Onboarding Variables)")]), _vm._v("\n                        ("), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#1a73e8",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.toggleNlpIntentDetectionVariable
    }
  }, [_vm._v(_vm._s(_vm.showNLPIntentDetectionVariableToggle ? 'Hide' : 'Show') + "  NLP Intent Detection Variables")]), _vm._v(")\n                      ")]), _vm._v(" "), (_vm.showNLPIntentDetectionVariableToggle) ? _c('div', [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.dynamicNlpVariables), function(variable) {
    return _c('li', {
      key: variable.name
    }, [_c('strong', [_vm._v(_vm._s('<<' + variable.name + '>>'))]), _vm._v(" - " + _vm._s(variable.description) + "\n                            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showGenAIOnboardingVairableToggle) ? _c('div', [_vm._m(2), _vm._v(" "), _c('ul', _vm._l((_vm.dynamicOnboardingVariables), function(variable) {
    return _c('li', {
      key: variable.name
    }, [_c('strong', [_vm._v(_vm._s('<<' + variable.name + '>>'))]), _vm._v(" - " + _vm._s(variable.description) + "\n                            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.promptData.prompt),
      expression: "promptData.prompt",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "prompt",
      "rows": "4",
      "placeholder": "Enter Prompt"
    },
    domProps: {
      "value": (_vm.promptData.prompt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData, "prompt", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.prompt.$error && _vm.$v.promptData.prompt.$dirty),
      expression: "$v.promptData.prompt.$error && $v.promptData.prompt.$dirty"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Prompt is required")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.promptData.description),
      expression: "promptData.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "Enter Description"
    },
    domProps: {
      "value": (_vm.promptData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData, "description", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.description.$error && _vm.$v.promptData.description.$dirty),
      expression: "$v.promptData.description.$error && $v.promptData.description.$dirty"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Prompt description is required")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "modelVersion"
    }
  }, [_vm._v("LLM Model Version")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "modelVersion"
    },
    model: {
      value: (_vm.promptData.configuration.modelVersion),
      callback: function($$v) {
        _vm.$set(_vm.promptData.configuration, "modelVersion", $$v)
      },
      expression: "promptData.configuration.modelVersion"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Model Version")]), _vm._v(" "), _vm._l((_vm.modelVersions), function(model) {
    return _c('option', {
      key: model.value,
      domProps: {
        "value": model.value
      }
    }, [_vm._v("\n                                " + _vm._s(model.label) + "\n                              ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.configuration.modelVersion.$error),
      expression: "$v.promptData.configuration.modelVersion.$error"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Model version is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "llm-config-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "temperature"
    }
  }, [_vm._v("Temperature")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.promptData.configuration.temperature),
      expression: "promptData.configuration.temperature",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "temperature",
      "step": "0.01",
      "min": "0",
      "max": "2",
      "placeholder": "Enter Temperature (0-2)"
    },
    domProps: {
      "value": (_vm.promptData.configuration.temperature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData.configuration, "temperature", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.configuration.temperature.$error),
      expression: "$v.promptData.configuration.temperature.$error"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Temperature must be between 0 and 1")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "topP"
    }
  }, [_vm._v("Top P")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.promptData.configuration.topP),
      expression: "promptData.configuration.topP",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "topP",
      "step": "0.01",
      "min": "0",
      "max": "1",
      "placeholder": "Enter Top P (0-1)"
    },
    domProps: {
      "value": (_vm.promptData.configuration.topP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData.configuration, "topP", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.configuration.topP.$error),
      expression: "$v.promptData.configuration.topP.$error"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Top P must be between 0 and 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-10"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "topK"
    }
  }, [_vm._v("Top K")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.promptData.configuration.topK),
      expression: "promptData.configuration.topK",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "topK",
      "min": "1",
      "step": "1",
      "placeholder": "Enter Top K"
    },
    domProps: {
      "value": (_vm.promptData.configuration.topK)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData.configuration, "topK", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.configuration.topK.$error),
      expression: "$v.promptData.configuration.topK.$error"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Top K must be a positive integer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "maxOutputTokens"
    }
  }, [_vm._v("Max Output Tokens")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.promptData.configuration.maxOutputTokens),
      expression: "promptData.configuration.maxOutputTokens",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "maxOutputTokens",
      "min": "1",
      "step": "1",
      "placeholder": "Enter Max Output Tokens"
    },
    domProps: {
      "value": (_vm.promptData.configuration.maxOutputTokens)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData.configuration, "maxOutputTokens", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.promptData.configuration.maxOutputTokens.$error),
      expression: "$v.promptData.configuration.maxOutputTokens.$error"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Max Output Tokens must be a positive integer")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "owner"
    }
  }, [_vm._v("Owner")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.promptData.owner),
      expression: "promptData.owner",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "id": "owner",
      "placeholder": "Enter Owner Name"
    },
    domProps: {
      "value": (_vm.promptData.owner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData, "owner", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "age"
    }
  }, [_vm._v("Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.promptData.age),
      expression: "promptData.age",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "age",
      "placeholder": "Enter Age"
    },
    domProps: {
      "value": (_vm.promptData.age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData, "age", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "gender"
    },
    model: {
      value: (_vm.promptData.gender),
      callback: function($$v) {
        _vm.$set(_vm.promptData, "gender", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "promptData.gender"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Gender")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "location"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.promptData.location),
      expression: "promptData.location",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "location",
      "placeholder": "Enter Location"
    },
    domProps: {
      "value": (_vm.promptData.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promptData, "location", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invalidateCache),
      expression: "invalidateCache"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.invalidateCache) ? _vm._i(_vm.invalidateCache, null) > -1 : (_vm.invalidateCache)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invalidateCache,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.invalidateCache = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.invalidateCache = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.invalidateCache = $$c
        }
      }
    }
  }), _vm._v("\n                      Invalidate cache on save\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "chat-window"
  }, [_c('div', {
    staticClass: "load-more-container"
  }, [_c('button', {
    staticClass: "load-more-button",
    on: {
      "click": _vm.loadMoreMessages
    }
  }, [(_vm.loadingMoreMessages) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" Load more")])]), _vm._v(" "), _c('button', {
    staticClass: "create-session-button",
    on: {
      "click": function($event) {
        _vm.showCreateSessionModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New session")]), _vm._v(" "), (_vm.selectedSession) ? _c('nv-select', {
    staticClass: "session-select",
    attrs: {
      "placeholder": "Select Session"
    },
    on: {
      "change": _vm.onSessionChange
    },
    model: {
      value: (_vm.selectedSession),
      callback: function($$v) {
        _vm.selectedSession = $$v
      },
      expression: "selectedSession"
    }
  }, _vm._l((_vm.sessions), function(session) {
    return _c('option', {
      key: session.id,
      domProps: {
        "value": session.id
      }
    }, [_vm._v("\n                        " + _vm._s(session.session_name) + "\n                      ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "create-session-button",
    on: {
      "click": _vm.exportChat
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export")])], 1), _vm._v(" "), _c('div', {
    staticClass: "messages"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "sandbox-message"
    }, [(message.type === 'user') ? _c('div', {
      staticClass: "user-message chat-bubble--right"
    }, [_c('div', {
      staticClass: "message-sent-by"
    }, [_vm._v("You")]), _vm._v("\n                      " + _vm._s(message.text) + "\n                    ")]) : _vm._e(), _vm._v(" "), (message.type === 'api') ? _c('div', {
      staticClass: "chat-bubble chat-bubble--left"
    }, [_c('div', {
      staticClass: "message-sent-by"
    }, [_vm._v("Bot")]), _vm._v("\n                    " + _vm._s(message.text) + "\n                    ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input-box-container"
  }, [_c('form', {
    staticClass: "chatbot-form",
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    staticClass: "input-box",
    attrs: {
      "type": "text",
      "placeholder": "Type a message",
      "disabled": _vm.sendingMessage
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.sendingMessage
    }
  }, [(_vm.sendingMessage) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-paper-plane"
  })])])])])])])])])])])]), _vm._v(" "), (_vm.showCreateSessionModal) ? _c('CreateSandboxSession', {
    on: {
      "close": function($event) {
        _vm.showCreateSessionModal = false
      },
      "submitSession": _vm.handleSessionSubmit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("NLP Intent Detection Variables: ")]), _vm._v("You can use these variables in the prompt. They will get replaced with values at the time of execution:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("GenAI Onboarding Variables: ")]), _vm._v("You can use these variables in the prompt. They will get replaced with values at the time of execution:")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-58f88b87","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prompt-management/createOrUpdatePrompt.vue
// module id = AeD2
// module chunks = 1